import React from "react";

const VenueDetailSpecs = ({ id, participantNames, participantImage, ...rest }) => {
  return (
    <section className="section topless" id={id} {...rest}>
      <div className="container hor">
        <div className="spec-wrap">
          {participantNames.map((participant, index) => (
            <div key={index} className="spec-item">
              <div className="spec-head">
                <h4 className="sub-header">{participant.label}</h4>
              </div>
              <div className="body-18" style={{ whiteSpace: "pre-line" }}>
                {participant.value}
              </div>
            </div>
          ))}
        </div>
        <div className="half-arc-frame">
          <div className="arc-frame _100">
            <img
              loading="lazy"
              alt=""
              src={participantImage ?? "/assets/images/invitation-section.jpg"}
              className="arc-im"
            />
          </div>
        </div>
        <div className="corner-arc"></div>
      </div>
    </section>
  );
};

export default VenueDetailSpecs;
